import React from 'react'
import { useState, useEffect } from "react";
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { PostAPI } from "../../../ApiServices/ApiServices";

const ForgotPassword = ({ }) => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

  
    const sendCode = () => {
        if (!email) {
            alert("Please enter your email address.");
            return;
        }

        sendotpAPI({ email }, (response) => {
            if (response?.status === 1) {
                console.log("OTP sent successfully:", response.data);
                navigate('/verificationcodesent', { state: { email } });
            } else {
                console.error("Error sending OTP:", response?.message || "Unknown error");
                alert(response?.message || "Failed to send OTP. Please try again.");
            }
        });
    };

    const signIn = () => {
        navigate('/');
    }

    const sendotpAPI = (data, callback) => {
        PostAPI({ url: "/send_otp", data }, (response) => {
            console.log("OTP API Response:", response);
            if (response?.status === 1) {
                callback(response);
            } else {
                callback({ status: 0, message: response?.message || "Failed to send OTP" });
            }
        });
    };



    return (
        <div className='login-form container'>
            <div className='right-content'>
                <h4 className='form-head forgot-ps'>Forgot Password ?</h4>
                <p className='wel-content'>Enter you Email ID to reset it!</p>
            </div>
            <div className='form-box'>
                <Form>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email<span style={{color: "var(--red)"  }}>*</span></Form.Label>
                        <Form.Control type="email" placeholder="Enter Email ID here"
                            name='email'
                            className='login-input'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Form.Group>
                    <Button variant="primary" onClick={sendCode} className='mb-3'>
                        Send Code
                    </Button>
                    <Button variant="primary" onClick={signIn} className='back-sgin-btn'>
                        Back to Signin
                    </Button>
                </Form>
            </div>

        </div>
    )
}

export default ForgotPassword